class c extends HTMLElement {
  constructor() {
    super(), this.initPageTracking = () => {
      var e, t;
      this.dataLayer = {
        environment: {
          environmentVersion: "V7",
          coBrandedVersion: this.coBrandedVersion
        },
        page: {
          pageType: this.pageType
        }
      }, this.pageFamilyName && (this.dataLayer.page.pageFamilyName = this.pageFamilyName), this.productRmc && (this.dataLayer.products || (this.dataLayer.products = { productRMC: null }), this.dataLayer.products.productRMC = this.productRmc), (t = (e = window.Shopify) == null ? void 0 : e.analytics) == null || t.publish("rlx_page_view", this.dataLayer);
    }, this.initLinkTracking = () => {
      document.addEventListener("click", (e) => {
        var a, r, n;
        const t = (a = e.target) == null ? void 0 : a.closest(
          `[${this.clickEventSelector}]`
        );
        if (!t || !e.target) return;
        const i = t.getAttribute(this.clickEventSelector);
        i && t.href != "" && (e.preventDefault(), (n = (r = window.Shopify) == null ? void 0 : r.analytics) == null || n.publish("rlx_event", { name: i }), window.location.href = t.href);
      });
    }, this.initFormTracking = () => {
      document.addEventListener("submit", (e) => {
        var r, n, s;
        const t = (r = e.target) == null ? void 0 : r.closest(
          `[${this.formEventSelector}]`
        );
        if (!t || !e.target) return;
        const i = t.hasAttribute("data-disable-rlx-submit"), a = t.getAttribute(this.formEventSelector);
        a && (i || e.preventDefault(), (s = (n = window.Shopify) == null ? void 0 : n.analytics) == null || s.publish("rlx_event", { name: a }), i || t.submit());
      });
    }, this.pageType = this.getAttribute("page-type"), this.coBrandedVersion = this.getAttribute("co-branded-version"), this.pageFamilyName = this.getAttribute("page-family-name"), this.productRmc = this.getAttribute("product-rmc"), this.clickEventSelector = "data-rlx-click", this.formEventSelector = "data-rlx-form";
  }
  connectedCallback() {
    this.initPageTracking(), this.initLinkTracking(), this.initFormTracking();
  }
}
window.customElements.define("rlx-page-tracking", c);
export {
  c as RlxPageTracking
};
